module.exports = __webpack_public_path__ + "images/5-ighf24a8ae8fe70188f0fd981d01646b90a5.svg";